module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 6
// module chunks = 0 1